<ng-container *transloco="let t;">
    <div class="guideline-suggestion-wrapper">
        <div class="guideline-detail">
            <div class="header d-flex justify-content-between align-items-center px-2 mb-2 py-2 border-bottom">
                <h3 class="mb-0 font-medium-1 fw-bold">{{ t("Guideline status headline text (Template/Legal hub tab - section) - Guideline") }}</h3>
                <span class="d-flex" (click)="closeMenu()">
                    <i [data-feather]="'x'" class="cursor-pointer"></i>
                </span>
            </div>

          <app-lh-suggestion-content [data]="data"></app-lh-suggestion-content>
        </div>
    </div>
</ng-container>